import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { InMemoryScrollingOptions, provideRouter, withInMemoryScrolling, withViewTransitions } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppConfigService } from './shared/services/app-config.service';
import { authInterceptor } from './shared/interceptors/auth.interceptor';

const scrollConfig: InMemoryScrollingOptions = {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes, withInMemoryScrolling(scrollConfig), withViewTransitions()),
        provideHttpClient(withInterceptors([authInterceptor])),
        provideAnimations(),
        {
            provide: APP_INITIALIZER,
            useFactory: (appConfig: AppConfigService) => () => appConfig.carregar(),
            deps: [AppConfigService],
            multi: true,
        },
    ],
};
